export default __webpack_public_path__ + "static/media/19.909a7fd4.mp4";